export default "__VITE_ASSET__cLl5Vitv__"